import { Checkbox, Modal } from 'antd';
import styled from 'styled-components';
import { BlueColors, GreenColors, NeutralColors } from 'theme';

const StyledModal = styled(Modal)`
  .fms-modal-content {
    padding: 24px;
    border-radius: 10px;
  }

  .fms-modal-body {
    padding: 0;
  }

  .fms-modal-footer {
    margin-top: 24px;
    padding: 0;
    border-top: none;
  }
`;

const IconWrapper = styled.div`
  align-items: center;
  background-color: ${BlueColors[10]};
  border-radius: 40px;
  display: flex;
  height: 80px;
  justify-content: center;
  margin: 0 auto 16px;
  width: 80px;

  svg {
    color: ${BlueColors[60]};
    fill: ${BlueColors[60]};
    height: 40px;
    width: 40px;
  }
`;

const Title = styled.h2`
  color: ${NeutralColors[100]};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin: 0 0 8px;
  text-align: center;
`;

const Description = styled.p`
  color: ${NeutralColors[70]};
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin: 0 0 20px;
  text-align: center;
`;

const BenefitsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0 0 24px;
  padding: 0;
`;

const BenefitItem = styled.li`
  align-items: center;
  color: ${NeutralColors[100]};
  display: flex;
  font-size: 14px;
  gap: 8px;
  line-height: 22px;

  svg {
    color: ${GreenColors[50]};
    fill: ${GreenColors[50]};
    flex-shrink: 0;
    height: 16px;
    width: 16px;
  }
`;

const DontShowAgainCheckbox = styled(Checkbox)`
  margin-top: 4px;

  .fms-checkbox-inner {
    border-radius: 4px;
  }

  .fms-checkbox + span {
    color: ${NeutralColors[70]};
    font-size: 14px;
    line-height: 22px;
  }
`;

const FooterActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;

  svg {
    fill: ${NeutralColors[0]};
  }
`;

export {
  BenefitItem,
  BenefitsList,
  Description,
  DontShowAgainCheckbox,
  FooterActions,
  IconWrapper,
  StyledModal,
  Title,
};
